import React, { Component } from "react";
import { DateRangePicker } from "react-dates";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { connect } from "react-redux";
import MediaQuery from "react-responsive";
import Select from "react-select";
import { Alert, Card, CardBody, CardHeader, Col, Label, Row } from "reactstrap";
import { bindActionCreators } from "redux";
import { layout, messages, roles } from "../../../../common/constants";
import { formatHelper } from "../../../../common/helpers";
import { DataTable, ExportCSV } from "../../../../components";
import {
  getReceiptBalance as receiptBalanceExport,
  getReceiptSellsBalance as receiptBalanceDetailedExport,
} from "../../../../service/report";
import {
  getReceiptBalance,
  getReceiptSellsBalance,
} from "../../../../store/report/actions";
import { selectReceiptBalance } from "../../../../store/report/selector";
import { getStores } from "../../../../store/store/actions";
import { selectStoresForSelect } from "../../../../store/store/selector";
import { selectUserRole } from "../../../../store/user/selector";
import { exportExcel, exportExcelGeneral } from "./excel";
import * as columns from "./_columns";

class ReceiptBalance extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startDate: null,
      endDate: null,
      focusedInput: null,
      page: 1,
      pageSells: 1,
      loadingExport: false,
      selectedStore: null,
    };
    this.handleStoreChange = this.handleStoreChange.bind(this);

    this.handleObtainReportExport = this.handleObtainReportExport.bind(this);

    this.handleObtainDetailedReportExport =
      this.handleObtainDetailedReportExport.bind(this);

    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleSellsPageChange = this.handleSellsPageChange.bind(this);
  }

  async handleStoreChange(value) {
    if (value == this.state.selectedStore) return;
    await this.setState({ selectedStore: value, page: 1 });

    if (
      this.state.startDate &&
      this.state.endDate &&
      this.state.selectedStore
    ) {
      this.performGetReceiptBalance();
      this.performGetReceiptSellsBalance();
    }
  }

  async componentDidMount() {
    await this.props.getStores({ reset: true });
    //await this.performGetEmployeesBalance(true)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.stores.length == 0 && this.props.stores.length > 0) {
      this.setState({ selectedStore: this.props.stores[0] });
    }
  }

  async handleReceiptBalanceDateChange(startDate, endDate) {
    await this.setState({ startDate, endDate });

    if (startDate != null && endDate != null) {
      this.performGetReceiptSellsBalance();
      this.performGetReceiptBalance();
    }
  }

  performGetReceiptBalance(reset = false) {
    const { getReceiptBalance } = this.props;
    const { page, startDate, endDate } = this.state;
    const store = this.state.selectedStore.value;

    getReceiptBalance({
      page,
      startDate: startDate._d,
      endDate: endDate._d,
      store,
      reset,
    });
  }

  performGetReceiptSellsBalance(reset = false) {
    const { getReceiptSellsBalance } = this.props;
    const { pageSells, startDate, endDate } = this.state;
    const store = this.state.selectedStore.value;
    getReceiptSellsBalance({
      page: pageSells,
      startDate: startDate._d,
      endDate: endDate._d,
      store,
      reset,
    });
  }

  async handlePageChange(page) {
    await this.setState({ page: page });
    this.performGetReceiptBalance();
  }

  async handleSellsPageChange(page) {
    await this.setState({ pageSells: page });
    this.performGetReceiptSellsBalance();
  }

  renderDataTable(
    columns,
    data,
    page,
    total,
    pageSize,
    loading,
    handlePageChange
  ) {
    return (
      <DataTable
        data={data}
        keyField="id"
        columns={columns}
        page={page}
        totalSize={total}
        sizePerPage={pageSize}
        loading={loading}
        onPageChange={handlePageChange}
      />
    );
  }

  renderDataTableBalance(
    columns,
    data,
    page,
    total,
    pageSize,
    loading,
    handlePageChange
  ) {
    return (
      <DataTable
        data={data}
        keyField="receipt_type"
        columns={columns}
        page={page}
        totalSize={total}
        sizePerPage={pageSize}
        loading={loading}
        onPageChange={handlePageChange}
      />
    );
  }

  handleObtainDetailedReportExport() {
    this.setState({ loadingExport: true });
    const { startDate, endDate, selectedStore } = this.state;
    receiptBalanceDetailedExport(
      0,
      startDate._d,
      endDate._d,
      selectedStore.value
    )
      .then((response) => {
        exportExcel(response.data.data, selectedStore, startDate, endDate);
      })
      .finally(() => {
        this.setState({ loadingExport: false });
      });
  }

  handleObtainReportExport() {
    this.setState({ loadingExport: true });
    const { startDate, endDate, selectedStore } = this.state;
    receiptBalanceExport(
      0,
      this.state.startDate._d,
      this.state.endDate._d,
      this.state.selectedStore.value
    )
      .then((response) => {
        exportExcelGeneral(
          response.data.data,
          selectedStore,
          startDate,
          endDate
        );
      })
      .finally(() => {
        this.setState({ loadingExport: false });
      });
  }

  render() {
    const { startDate, endDate, loadingExport } = this.state;

    const {
      receiptSells,
      receiptSellsLoading,
      receiptSellsTotal,
      receiptSellsPageSize,
      totalBought,
      receiptSellsError,
      receiptBalance,
      receiptBalanceTotal,
      receiptBalancePageSize,
      receiptBalanceError,
      receiptBalanceLoading,
    } = this.props;

    return (
      <div>
        <Card>
          <CardHeader>
            <i className="icon-chart"></i>Balance por Recibo
          </CardHeader>
          <CardBody>
            <div>
              {(this.props.role == roles.SUPER_ADMIN ||
                this.props.role == roles.ADMIN) && (
                <Row className="my-4">
                  <Col sm="1">
                    <Label className="mt-2">Tienda:</Label>
                  </Col>

                  <Col sm="4">
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      isLoading={this.props.loadingStores}
                      isSearchable={true}
                      noOptionsMessage={() => {
                        return messages.SELECT_NO_OPTIONS;
                      }}
                      placeholder=""
                      options={this.props.stores}
                      loadingMessage={() => {
                        return messages.SELECT_LOADING;
                      }}
                      onChange={this.handleStoreChange}
                      value={this.state.selectedStore}
                      isDisabled={
                        this.props.loadingStores ||
                        receiptSellsLoading ||
                        receiptBalanceLoading
                      }
                    />
                  </Col>
                </Row>
              )}

              <Row className="mb-2">
                <Col md="5">
                  <DateRangePicker
                    startDate={startDate}
                    startDateId="startDate"
                    endDate={endDate}
                    endDateId="endDate"
                    displayFormat={"DD/MM/YYYY"}
                    disabled={
                      this.props.loadingStores ||
                      receiptSellsLoading ||
                      receiptBalanceLoading
                    }
                    onDatesChange={({ startDate, endDate }) =>
                      this.handleReceiptBalanceDateChange(startDate, endDate)
                    }
                    focusedInput={this.state.focusedInput}
                    onFocusChange={(focusedInput) =>
                      this.setState({ focusedInput })
                    }
                    startDatePlaceholderText="Fecha Inicio"
                    endDatePlaceholderText="Fecha Fin"
                    small
                    isOutsideRange={() => false}
                    hideKeyboardShortcutsPanel
                    minimumNights={0}
                  />
                </Col>
                <Col md="7">
                  {this.state.startDate && this.state.endDate ? (
                    <Row>
                      <Col md="12">
                        <ExportCSV
                          disabled={loadingExport}
                          exportCSV={this.handleObtainReportExport}
                          minWidth={800}
                        />
                        <ExportCSV
                          disabled={loadingExport}
                          exportCSV={this.handleObtainDetailedReportExport}
                          minWidth={800}
                          detailed={true}
                        />
                      </Col>
                    </Row>
                  ) : null}
                </Col>
              </Row>
              <hr className="my-4" />
              {startDate != null && endDate != null ? (
                <Row>
                  <Col>
                    <Row className="mb-2">
                      <Col>
                        <b>Total de Ventas (S/):</b>{" "}
                        {formatHelper.toMoney(totalBought)}
                      </Col>
                    </Row>
                    <Row>
                      {receiptSellsError && (
                        <Col xs="12">
                          <Alert color="danger">{receiptSellsError}</Alert>
                        </Col>
                      )}
                      <Col>
                        <MediaQuery maxWidth={layout.XS_MAX_WIDTH}>
                          {this.renderDataTable(
                            columns.columnsCategorySellsXS,
                            receiptSells,
                            this.state.pageSells,
                            receiptSellsTotal,
                            receiptSellsPageSize,
                            receiptSellsLoading,
                            this.handleSellsPageChange
                          )}
                        </MediaQuery>
                        <MediaQuery
                          minWidth={layout.SM_MIN_WIDTH}
                          maxWidth={layout.MD_MAX_WIDTH}
                        >
                          {this.renderDataTable(
                            columns.columnsCategorySellsSM,
                            receiptSells,
                            this.state.pageSells,
                            receiptSellsTotal,
                            receiptSellsPageSize,
                            receiptSellsLoading,
                            this.handleSellsPageChange
                          )}
                        </MediaQuery>
                        <MediaQuery minWidth={layout.LG_MIN_WIDTH}>
                          {this.renderDataTable(
                            columns.columnsCategorySellsMD,
                            receiptSells,
                            this.state.pageSells,
                            receiptSellsTotal,
                            receiptSellsPageSize,
                            receiptSellsLoading,
                            this.handleSellsPageChange
                          )}
                        </MediaQuery>
                      </Col>
                    </Row>
                    <hr className="my-4" />
                    <Row>
                      {receiptBalanceError && (
                        <Col xs="12">
                          <Alert color="danger">{receiptBalanceError}</Alert>
                        </Col>
                      )}
                      <Col>
                        <MediaQuery maxWidth={layout.XS_MAX_WIDTH}>
                          {this.renderDataTableBalance(
                            columns.columnsCategoryBlanceXS,
                            receiptBalance,
                            this.state.page,
                            receiptBalanceTotal,
                            receiptBalancePageSize,
                            receiptBalanceLoading,
                            this.handlePageChange
                          )}
                        </MediaQuery>
                        <MediaQuery minWidth={layout.SM_MIN_WIDTH}>
                          {this.renderDataTableBalance(
                            columns.columnsCategoryBlanceSM,
                            receiptBalance,
                            this.state.page,
                            receiptBalanceTotal,
                            receiptBalancePageSize,
                            receiptBalanceLoading,
                            this.handlePageChange
                          )}
                        </MediaQuery>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col>
                    <Alert color="info">
                      Seleccione un rango de fechas para visualizar los datos
                    </Alert>
                  </Col>
                </Row>
              )}
            </div>
          </CardBody>
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { receiptSellsBalanceList, receiptBalanceList } = state.report;

  return {
    receiptSells: selectReceiptBalance(state),
    receiptSellsLoading: receiptSellsBalanceList.loading,
    receiptSellsTotal: receiptSellsBalanceList.total,
    receiptSellsPageSize: receiptSellsBalanceList.pageSize,
    receiptSellsError: receiptSellsBalanceList.error,
    totalBought: receiptSellsBalanceList.totalBought,

    receiptBalance: receiptBalanceList.receiptBalance,
    receiptBalanceTotal: receiptBalanceList.total,
    receiptBalancePageSize: receiptBalanceList.pageSize,
    receiptBalanceError: receiptBalanceList.error,
    receiptBalanceLoading: receiptBalanceList.loading,
    role: selectUserRole(state),
    stores: selectStoresForSelect(state),
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getReceiptBalance,
      getReceiptSellsBalance,
      getStores,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ReceiptBalance);



// WEBPACK FOOTER //
// ./src/scenes/Report/Balance/ReceiptBalance/ReceiptBalance.js